export default [
  {
    path: 'providers',
    name: 'list-debt-providers',
    component: () =>
      import(/* webpackChunkName: "list-debt-providers" */ './list/index.vue'),
    meta: {
      title: 'Công nợ nhà cung cấp  - Clickbuy',
    },
  },
];
